export default __webpack_public_path__ + "static/media/ic-sm-sowing-3.29fcdfc0.svg";